<script>
    export default {
        name: "LazyImage",
        props: {
            'showing': Boolean,
            'src': String
        },
        data(){
            return {
                imageSrc: null
            }
        },
        watch: {
            showing(newValue){
                if(newValue)
                this.imageSrc = this.src
            }
        }
    }
</script>
<template>
    <img :src="imageSrc">
</template>